import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-footer-brand-socials',
    imports: [CommonModule, MatIconModule, MatTooltipModule],
    templateUrl: './app-footer-brand-socials.component.html',
    styleUrls: ['./app-footer-brand-socials.component.scss'],
})
export class AppFooterBrandSocialsComponent {}
